import { calendarConfig } from '../Contents/TimeSheet/calendarConfig';
import dateTimeHelper from '../Helpers/datetimeHelper';

export default class TimeSheetEntry {
  constructor(startDate, endDate, startTime, endTime, taskName, comment) {
    const realStartDate = Date.parse(`${startDate.replaceAll('.', '-')} ${startTime} (UTC)`);
    const realEndDate = Date.parse(`${endDate.replaceAll('.', '-')} ${endTime} (UTC)`);

    this.startDate = dateTimeHelper.toYYYYsMMsDD(realStartDate, '.');
    this.endDate = dateTimeHelper.toYYYYsMMsDD(realEndDate, '.');
    this.startTime = startTime;
    this.endTime = endTime;
    this.taskName = taskName;
    this.comment = comment === undefined ? '' : comment;
    this.id = '';
    this.serviceType = '';
    this.isOutsourced = false;

    this.tempStartDate = this.startDate;
    this.tempEndDate = this.endDate;
    this.tempStartTime = this.startTime;
    this.tempEndTime = this.endTime;

    this.showEntry = false;
  }

  calculateShownTimePosition(calendarParameters, showBeforeWorkingHours, showAfterWorkingHours) {
    this.tempStartDate = this.displayStartDate == null ? this.startDate : this.displayStartDate;
    this.tempEndDate = this.displayEndDate == null ? this.endDate : this.displayEndDate;
    this.tempStartTime = this.displayStartTime == null ? this.startTime : this.displayStartTime;
    this.tempEndTime = this.displayEndTime == null ? this.endTime : this.displayEndTime;

    const entryStartDate = new Date(
      dateTimeHelper
        .getDateFromDateStringForFF(this.startDate)
        .setHours(
          dateTimeHelper.getHoursFromTimeString(this.startTime),
          dateTimeHelper.getMinutesFromTimeString(this.startTime),
          0
        )
    ); // Because of Firefox
    // var entryEndDate = new Date(dateTimeHelper.getDateFromDateStringForFF(this.endDate).setHours(dateTimeHelper.getHoursFromTimeString(this.endTime),dateTimeHelper.getMinutesFromTimeString(this.endTime), 0));//Because of Firefox
    if (!entryStartDate || !calendarParameters.firstDay || !calendarParameters.lastDay) return;
    this.showEntry =
      entryStartDate.getTime() >= calendarParameters.firstDay.getTime() - 24 * 60 * 60 * 1000 &&
      entryStartDate.getTime() <= calendarParameters.lastDay.getTime();

    if (this.showEntry) {
      if (dateTimeHelper.getDateFromDateString(this.startDate) < calendarParameters.firstDay) {
        this.tempStartDate = dateTimeHelper.getFormattedDate(calendarParameters.firstDay, '.');
      }

      if (dateTimeHelper.getDateFromDateString(this.endDate) > calendarParameters.lastDay) {
        this.tempEndDate = dateTimeHelper.getFormattedDate(calendarParameters.lastDay);
      }
    }

    if (
      !showBeforeWorkingHours &&
      dateTimeHelper.convertTimeToMinutes(this.startTime) <
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkStartTime)
    ) {
      if (
        dateTimeHelper.convertTimeToMinutes(this.endTime) <
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkStartTime)
      ) {
        this.showEntry = false;
      } else {
        this.tempStartTime = calendarConfig.dailyWorkStartTime;
      }
    }

    if (
      !showAfterWorkingHours &&
      (this.displayEndDate !== undefined || // This only has value if it is the first part of an overnight entry
        dateTimeHelper.convertTimeToMinutes(this.endTime) >
          dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkEndTime) ||
        (this.tempStartDate !== this.tempEndDate &&
          Math.abs(new Date(this.tempStartDate).getTime() - new Date(this.tempEndDate).getTime()) ===
            1000 * 60 * 60 * 24 &&
          this.tempEndTime === '00:00'))
    ) {
      if (
        dateTimeHelper.convertTimeToMinutes(this.startTime) >
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkEndTime)
      ) {
        this.showEntry = false;
      } else {
        this.tempEndTime = calendarConfig.dailyWorkEndTime;
      }
    }

    if (
      !showAfterWorkingHours &&
      dateTimeHelper.convertTimeToMinutes(this.tempStartTime) >
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkEndTime)
    ) {
      this.showEntry = false;
    }

    if (
      !showBeforeWorkingHours &&
      dateTimeHelper.convertTimeToMinutes(this.tempStartTime) <
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkStartTime)
    ) {
      this.showEntry = false;
    }

    if (
      this.displayStartDate !== undefined &&
      dateTimeHelper.convertTimeToMinutes(this.tempStartTime) <
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkStartTime)
    ) {
      this.showEntry = !!showBeforeWorkingHours;
    }

    if (
      this.displayEndDate !== undefined &&
      dateTimeHelper.convertTimeToMinutes(this.tempEndTime) >
        dateTimeHelper.convertTimeToMinutes(calendarConfig.dailyWorkEndTime)
    ) {
      this.showEntry = !!showAfterWorkingHours;
    }
  }
}
